/* Логика для страниц каталога фильтрации программ */
const catalog = () => {
  if (!document.querySelector("[data-catalog-filters]")) {
    return;
  }

  const utmLevel = getParam("level"),
    utmRecruitment = getParam('recruitment'),
    inputsLevel = document.querySelectorAll('input[name="level"]'),
    inputsRecruitment = document.querySelectorAll('input[name="recruitment"]'),
    linksPrograms = document.querySelectorAll(".tile__link"),
    linksDirections = document.querySelectorAll("[catalog-filter]"),
    notFound = document.querySelector(".tiles__not-found"),
    wrap = document.querySelector(".tiles__programs");

  /* Список программ доступных для категории ищущих */
  const list = [
    'onec144',
    'accountant',
    'personneladmin',
    'methodist',
    'bpla',
    'preschool-education',
    'social-worker',
    'social-specialist',
    'softwaretesting',
    'webprogrammer'
  ];

  /* Инициализация */
  (() => {
    // Добавление активности для инпута на основе данных из utm метки
    if (utmLevel) {
      inputsLevel.forEach((input) => {
        if (input.value == utmLevel) {
          input.setAttribute("checked", "true");
        }
      });
    }

    if (utmRecruitment) {
      inputsRecruitment.forEach((input) => {
        if (input.value == utmRecruitment) {
          input.setAttribute('checked', 'true');
        }
      });
    }

    update();
    resetAllFilters();

    /* Замена текста в плашках для программ категории ищущих */
    linksPrograms.forEach((tile) => {
      if (list.includes(returnPageProgram(tile.href))) {
        if (!tile.closest(".tile").classList.contains('disable')) {
          let field = tile
            .closest(".tile")
            .querySelector(".tile__header-info-cost");
          field.textContent = "Бесплатно";
        }
      }
    });
  })();

  /* Функция добавления UTM меток в url сайта */
  const updateQueryStringParam = function (key, value) {
    let url = new URL(document.location.href);

    url.searchParams.set(key, value);
    window.history.replaceState({}, "", url.href);
  };

  /* Событие на чекбокс уровня образования */
  inputsLevel.forEach((input) => {
    input.addEventListener("change", () => {
      updateQueryStringParam("level", input.value);
      update();
      scrollToTop();
    });
  });

  /* Событие на чекбокс активного набора */
  inputsRecruitment.forEach((input) => {
    input.addEventListener('change', () => {
      updateQueryStringParam('recruitment', input.value);
      update();
      scrollToTop();
    });
  });

  /* Обновление контента */
  function update() {
    filterPrograms();
    blockDisplayLogic(searchValueCheckbox(inputsLevel), searchValueCheckbox(inputsRecruitment));
    addLinks();
  }

  /* Отображение или скрытие блока списка программ и notFound */
  function blockDisplayLogic(level, filter) {
    let countDPO = countPrograms(".tiles__DPO", "enable"),
      countPO = countPrograms(".tiles__PO", "enable"),
      DPO = document.querySelector(".tiles__DPO"),
      PO = document.querySelector(".tiles__PO");   

    if (level == 'DPO') {
      DPO.style.display = 'block';
      if (PO) {
        PO.style.display = 'none';
      }
      
      if (countDPO < 1) {
        wrap.style.display = 'none';
        notFound.style.display = 'flex';
      } else {
        wrap.style.display = 'flex';
        notFound.style.display = 'none';
      }
    } else if (level == 'PO') {
      DPO.style.display = 'none';
      if (PO) {
        PO.style.display = 'block';
      }

      if (countPO < 1) {
        wrap.style.display = 'none';
        notFound.style.display = 'flex';
      } else {
        wrap.style.display = 'flex';
        notFound.style.display = 'none';
      }
    } else {
      if (countDPO < 1 && countPO < 1) {
        wrap.style.display = 'none';
        notFound.style.display = 'flex';        
      } else if (countPO < 1) {
        if (PO) {
          PO.style.display = 'none';
        }
        wrap.style.display = 'flex';
        notFound.style.display = 'none';        
      } else if (countDPO < 1) {
        if (DPO) {
          DPO.style.display = 'none';
        }
        wrap.style.display = 'flex';
        notFound.style.display = 'none';        
      } else {
        if (PO) {
          PO.style.display = 'block';
        }
        if (DPO) {
          DPO.style.display = 'block';
        }
        wrap.style.display = 'flex';
        notFound.style.display = 'none';        
      }
    }

    //Фильтрация по активности программ
    if (filter == 'disable') {
      let checkDisableDPO = [...linksPrograms].find((it) => {
        if (level == 'DPO' && it.closest('.tiles__DPO')) {
          if (it.closest('.disable')) {
            return it;
          }
        }
      });

      let checkDisablePO = [...linksPrograms].find((it) => {
        if (level == 'PO' && it.closest('.tiles__PO')) {
          if (it.closest('.disable')) {
            return it;
          }
        }
      });

      let checkDisablePOAll = [...linksPrograms].find((it) => {
        if (it.closest('.tiles__PO')) {
          if (it.closest('.disable')) {
            return it;
          }
        }
      });

      let checkDisableDPOAll = [...linksPrograms].find((it) => {
        if (it.closest('.tiles__DPO')) {
          if (it.closest('.disable')) {
            return it;
          }
        }
      });

      if (level == 'DPO') {
        if (typeof checkDisableDPO == 'undefined') {
          wrap.style.display = 'none';
          notFound.style.display = 'flex';
        }
      } else if (level == 'PO') {
        if (typeof checkDisablePO == 'undefined') {
          wrap.style.display = 'none';
          notFound.style.display = 'flex';
        }
      } else {
        if (typeof checkDisablePOAll == 'undefined') {
          if (PO) {
            PO.style.display = 'none';
          }
        } else {
          if (PO) {
            PO.style.display = 'block';
          }
        }
        
        if (typeof checkDisableDPOAll == 'undefined') {
          if (DPO) {
            DPO.style.display = 'none';
          }
        } else {
          if (DPO) {
            DPO.style.display = 'block';
          }
        }

        if (
          typeof checkDisableDPOAll == 'undefined' &&
          typeof checkDisablePOAll == 'undefined'
        ) {
          wrap.style.display = 'none';
          notFound.style.display = 'flex';
        }
      }

      [...linksPrograms].map((it) => {
        it.closest('.tile').style.display = 'none';

        if (it.closest('.disable')) {
          it.closest('.tile').style.display = 'flex';
        }
      });
    } else {
      const enablePrograms = document.querySelectorAll(".tile:not(.disable)");

      if (level == "DPO") {      
        if (countPrograms('.tiles__DPO', "disable") == countPrograms('.tiles__DPO', "enable")) {
          if (DPO) {
            DPO.style.display = 'none';
            wrap.style.display = 'none';
            notFound.style.display = 'flex';
          }
        }
      } else if (level == "PO") {
        if (countPrograms('.tiles__PO', "disable") == countPrograms('.tiles__PO', "enable")) {
          if (PO) {
            PO.style.display = 'none';
            wrap.style.display = 'none';
            notFound.style.display = 'flex';
          }
        }           
      } else {
        if (countPrograms('.tiles__DPO', "disable") == countPrograms('.tiles__DPO', "enable")) {
          if (DPO) {
            DPO.style.display = 'none';
          }
        } else {
          if (DPO) {
            DPO.style.display = 'block';
          }
        }
        
        if (countPrograms('.tiles__PO', "disable") == countPrograms('.tiles__PO', "enable")) {
          if (PO) {
            PO.style.display = 'none';
          }
        } else {
          if (PO) {
            PO.style.display = 'block';
          }
        }        
        
        if (!enablePrograms.length) {
          wrap.style.display = 'none';
          notFound.style.display = 'flex';
        }
      }
    }
  }

  /* Фильтрация программ */
  function filterPrograms() {
    let count = 0;

    linksPrograms.forEach((tile) => {
      if (!tile.closest(".tile").classList.contains("disable")) {        
        if (count == 4) {
          count = 0;
        }

        count++;
        changeStateTiles(tile, count);
      } else {          
        tile.closest(".tile").style.display = "none";
      }
    });
  }
  
  /* Сброс установок фильтров */
  function resetAllFilters() {
    let resetAllFilters = document.querySelector('[data-reset-all]');

    resetAllFilters.addEventListener('click', () => {
      document.location.href = '/catalog';
    });
  }

  /* Отобраение и замена цвета у карточек каталога */
  function changeStateTiles(tile, count) {
    const colors = [
      ["#FFB84F", "#FFC877"],
      ["#FF9F9F", "#FFBABE"],
      ["#64BBFF", "#82C7FC"],
      ["#9896FF", "#AFAEF2"],
    ];

    if (tile.closest(".tile").classList.contains("hidden")) {
      tile.closest(".tile").classList.remove("hidden");
    }

    tile.closest(".tile").style.backgroundColor = colors[count - 1][0];
    tile.closest(".tile").querySelectorAll(".tile__header-icon").forEach((icon) => icon.style.backgroundColor = colors[count - 1][1]);

    tile.closest(".tile").style.display = "flex";
    tile.closest(".tile").classList.add("visible");

    if (tile.closest('.disable')) {
      tile.closest('.tile').style.display = 'none';
    }
  }

  /* Скрытие карточки в каталоге */
  function hiddenTiles(tile) {
    if (tile.closest(".tile").classList.contains("visible")) {
      tile.closest(".tile").classList.remove("visible");
    }

    tile.closest(".tile").classList.add("hidden");
    tile.closest(".tile").style.display = "none";
  }

  /* Скрытие или отображение блока для программ ДПО и ПО */
  function countPrograms(block, filter) {
    const wrap = document.querySelector(block);

    if (!wrap) {
      return 0;
    }

    if (filter == "disable") {      
      const programs = wrap.querySelectorAll('.tile.visible.disable');
      return programs.length;
    } else {
      const programs = wrap.querySelectorAll('.tile.visible');
      return programs.length;
    }
  }

  /* Добавление для ссылок на направлениях utm меток */
  function addLinks() {
    let level = searchValueCheckbox(inputsLevel);

    if (level) {
      linksDirections.forEach((link) => {
        let href = link.href;
        link.href = href.split("?")[0] + `?level=${level}`;
      });
    } else {
      linksDirections.forEach((link) => {
        let href = link.href;
        link.href = href.split("?")[0];
      });
    }
  }

  /* Поиск выбранного чекбокса */
  function searchValueCheckbox(inputs) {
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) {
        let value = inputs[i].value;

        return value;
      }
    }
  }

  /* Получение url программы из ссылки */
  function returnPageProgram(link) {
    const segments = link.split("/"),
      last = segments.pop() || segments.pop();

    return last;
  }

  /* Функция получения определенной utm метки */
  function getParam(param) {
    const urlParams = new URL(window.location.toString()).searchParams;
    return urlParams.get(param) || "";
  }

  /* Плавный скролл в начало блока списка программ */
  function scrollToTop() {
    let scropllBlock = document.querySelector(".tiles-wrap");
    if (scropllBlock) {
      scropllBlock.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }
};

export default catalog;
